import React, { useState, useMemo, useEffect, useRef } from "react";
// Plik ma 17 wlasnych ikon (nizej), wiec ze wspolnego zestawu bierzemy tylko te dwie,
// ktorych tu brakowalo, zamiast dublowac istniejace nazwy.
import { UsersIcon, StarIcon } from '../ui/icons';
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../translations";
import { slideIn, PanelContainer as Container, PanelCard as Card, Title, Subtitle, PrimaryButton, SecondaryButton, IconBadge } from "../ui/common";

// Rotacja tonów awatara klienta — patrz ICON_TONES w ui/common.js. 'gold' celowo pominięty:
// zbyt blisko --warning, a numer telefonu/adres klienta bywa obok podświetlony ostrzeżeniem.
const CLIENT_AVATAR_TONES = ['steel', 'clay', 'pine', 'dusk'];
import { API_BASE } from '../config';
import { scrollToTop } from '../utils/scrollToTop';
import ClientExportModal from '../components/clients/ClientExportModal';


// Allow dropdowns to overflow above client cards on this page
const LocalContainer = styled(Container)`
  overflow: visible;
`;

// Ikony SVG
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
    <path d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const FilterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MailIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/>
    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const CalendarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const UserIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const TrendingUpIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" stroke="currentColor" strokeWidth="2"/>
    <polyline points="17,6 23,6 23,12" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const ExternalLinkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke="currentColor" strokeWidth="2"/>
    <polyline points="15,3 21,3 21,9" stroke="currentColor" strokeWidth="2"/>
    <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const SortIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 6h18M7 12h10M11 18h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const HomeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2"/>
    <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

// DODANE: Nowe ikony
const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="3,6 5,6 21,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="10" y1="11" x2="10" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="14" y1="11" x2="14" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const AlertTriangleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// DODANE: Nowa ikona do edycji
const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 1 2-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="20,6 9,17 4,12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const RefreshIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="23 4 23 10 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="1 20 1 14 7 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Animacje i style
const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  gap: 16px;
  animation: ${slideIn} 0.6s ease-out;
  
  @media(max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  
  @media(max-width: 768px) {
    width: 100%;
  }
`;

const IconButton = styled.button`
  background: var(--card-bg);
  color: var(--text);
  border: 1px solid var(--input-border);
  width: 44px;
  height: 44px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover:not(:disabled) {
    background: var(--hover-bg);
    transform: translateY(-1px);
    box-shadow: var(--shadow-sm);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
  animation: ${slideIn} 0.6s ease-out;
`;

const ToolbarSection = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  flex: 1;
  min-width: 300px;

  @media (max-width: 768px) {
    min-width: auto;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 44px;
  border: 2px solid var(--input-border);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text);
  transition: all 0.2s ease;

  &:focus {
    border-color: var(--primary);
    box-shadow: var(--focus-ring);
  }

  &::placeholder {
    color: var(--text-muted);
  }
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
`;

const FilterRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

const FilterSelect = styled.select`
  padding: 8px 12px;
  border: 2px solid var(--input-border);
  border-radius: 8px;
  font-size: 13px;
  background: var(--input-bg);
  color: var(--text);
  min-width: 120px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

// Reuse inventory-style dropdown visuals (custom listbox)
const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
  z-index: var(--z-dropdown); /* ensure dropdown root is above client cards */
`;

const FilterDropdownButton = styled.button`
  width: 100%;
  padding: 10px 14px;
  min-height: 44px;
  border: 2px solid var(--input-border);
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 500;
  background: var(--input-bg);
  color: var(--text);
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.2;
  transition: border-color .2s, box-shadow .2s, background .2s;
  gap: 8px;
  box-sizing: border-box;

  & > span:first-child {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 28px);
  }

  &:hover { border-color: var(--primary); }
  &:focus-visible {
    outline: none;
    border-color: var(--primary);
    background: var(--card-bg);
    box-shadow: var(--focus-ring);
  }
  &[data-open="true"] {
    border-color: var(--primary);
    background: var(--card-bg);
    box-shadow: var(--focus-ring);
    svg { color: var(--primary); }
  }
  svg { flex-shrink: 0; transition: color .2s; color: var(--text-muted); }
`;

const FilterOptionsList = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 220px;
  margin: 0;
  padding: 4px;
  list-style: none;
  background: var(--card-bg);
  border: 1px solid var(--input-border);
  border-radius: 12px;
  box-shadow: 0 8px 32px var(--shadow-color);
  overflow-y: auto;
  z-index: var(--z-dropdown);
`;

const FilterSearchInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--input-border);
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 500;
  background: var(--input-bg);
  color: var(--text);
  box-sizing: border-box;
  margin-bottom: 6px;

  &:focus { outline: none; border-color: var(--primary); box-shadow: var(--focus-ring); }
`;

const FilterOptionItem = styled.li`
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text);
  cursor: pointer;
  transition: background .15s, color .15s;

  .option-content { display:flex; align-items:center; gap:8px; }
  .option-content svg { color: var(--primary); flex-shrink:0; }
  .option-label { flex:1; }

  &:hover { background: var(--table-row-hover); }
  &[data-selected="true"] {
    background: color-mix(in srgb, var(--primary) 12%, transparent);
    color: var(--primary);
    font-weight: 600;
  }
`;

const DotIcon = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="3" fill="currentColor" />
  </svg>
);

// Reusable small FilterDropdown component (inventory style)
function FilterDropdown({ value, onChange, options, placeholder }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    document.addEventListener('scroll', handler, true);
    const onWheel = (e) => {
      const t = e.target;
      if (t && t.tagName === 'INPUT' && t.type === 'number' && wrapperRef.current && wrapperRef.current.contains(t)) {
        e.preventDefault();
      }
    };
    document.addEventListener('wheel', onWheel, { passive: false, capture: true });
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('scroll', handler, true);
      document.removeEventListener('wheel', onWheel, { capture: true });
    };
  }, [open]);

  const selected = options.find(o => o.value === value) || options[0];

  return (
    <div style={{ minWidth: 160 }}>
      <DropdownWrapper ref={wrapperRef}>
        <FilterDropdownButton
          type="button"
          data-open={open}
          aria-haspopup="listbox"
          aria-expanded={open}
          onClick={() => setOpen(o => !o)}
        >
          <span>{selected ? selected.label : placeholder}</span>
          {open ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 15l-6-6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          )}
        </FilterDropdownButton>

        {open && (
          <FilterOptionsList role="listbox">
            {options.map(o => {
              const sel = o.value === value;
              return (
                <FilterOptionItem
                  key={o.value}
                  data-selected={sel}
                  onClick={() => { onChange(o.value); setOpen(false); }}
                >
                  <span className="option-content">
                    {sel && <DotIcon />}
                    <span className="option-label">{o.label}</span>
                  </span>
                </FilterOptionItem>
              );
            })}
          </FilterOptionsList>
        )}
      </DropdownWrapper>
    </div>
  );
}

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

const StatCard = styled.div`
  background: var(--card-bg);
  border: 1px solid var(--input-border);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px var(--shadow-color);
  }
`;

// Wspólna plakietka ikony z ui/common.js (IconBadge) — wołający przekazuje `$tone="steel"` itp.
// zamiast `bg="var(--primary)"`, patrz komentarz przy ICON_TONES w ui/common.js.
const StatIcon = styled(IconBadge).attrs({ $size: 48 })``;

const StatContent = styled.div`
  flex: 1;
`;

const StatValue = styled.div`
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text);
  line-height: 1;
`;

const StatLabel = styled.div`
  font-size: 0.875rem;
  color: var(--text-muted);
  margin-top: 4px;
`;

const ClientGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ClientCard = styled.div`
  background: var(--card-bg);
  border: 1px solid var(--input-border);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px var(--shadow-color);
    border-color: var(--primary);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--primary);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }
`;

const ClientHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

// Ton z getClientTone (rotacja ICON_TONES) zamiast stałego --primary — patrz komentarz przy tej
// funkcji: bez tego cała lista klientów to rząd identycznych niebieskich kwadratów.
const ClientAvatar = styled(IconBadge).attrs({ $size: 48 })`
  font-weight: 700;
  font-size: 1.125rem;
`;

const ClientName = styled.h3`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text);
  line-height: 1.3;
`;

const ClientInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: var(--text-muted);
`;

const ClientStats = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid var(--input-border);
`;

const ReservationsBadge = styled.div`
  background: var(--success);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const JoinDate = styled.div`
  font-size: 0.75rem;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ViewMoreButton = styled.button`
  background: none;
  border: 1px solid var(--input-border);
  color: var(--text);
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;

  &:hover {
    background: var(--hover-bg);
    border-color: var(--primary);
    color: var(--primary);
  }
`;

const ErrorMessage = styled.div`
  background: var(--danger-bg);
  color: var(--danger);
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  border: 1px solid var(--danger-border);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;

  [data-theme='dark'] & {
    background: var(--danger-bg);
    border-color: var(--danger-border);
  }
`;

const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: var(--text-muted);
  font-size: 16px;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 80px 20px;
  color: var(--text-muted);
`;

const EmptyIcon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.5;
`;

const EmptyTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text);
`;

const EmptyText = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-muted);
  max-width: 400px;
  margin: 0 auto;
  line-height: 1.5;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid var(--input-border);
`;


const ReservationsButton = styled(SecondaryButton)`
  background: var(--primary);
  color: var(--primary-contrast);
  border: 2px solid transparent;
  font-weight: 600;
  box-shadow: var(--shadow-primary);
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: var(--primary-hover);
    transform: translateY(-2px);
    box-shadow: var(--shadow-primary);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    color: currentColor;
  }
`;

const PageInfo = styled.span`
  color: var(--text-muted);
  font-size: 14px;
  margin: 0 12px;
`;

const Modal = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
  backdrop-filter: blur(6px);
`;

const ModalContent = styled.div`
  background: var(--card-bg);
  border-radius: 20px;
  padding: 32px;
  min-width: 760px; /* zwiększone, żeby pomieścić dwie kolumny */
  width: min(900px, calc(100vw - 64px));
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  box-shadow: var(--shadow-lg);
  animation: ${slideIn} 0.3s ease-out;
  border: 1px solid var(--input-border);

  @media (max-width: 900px) {
    min-width: auto;
    width: calc(100% - 40px);
    margin: 20px;
    padding: 24px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--input-border);
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text);
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--text-muted);
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--danger-bg);
    color: var(--danger);
  }
`;

const DetailGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr)); /* dwie kolumny na wystarczająco szerokim ekranie */

  @media (max-width: 900px) {
    grid-template-columns: 1fr; /* jedna kolumna na mniejszych ekranach */
  }
`;

const DetailItem = styled.div`
  padding: 20px;
  background: var(--input-bg);
  border-radius: 12px;
  border: 1px solid var(--input-border);
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const DetailLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
`;

const DetailValue = styled.div`
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text);
  word-wrap: break-word;
  word-break: break-all;
  line-height: 1.4;
  flex: 1;
  display: flex;
  align-items: center;
  
  /* Dla długich emaili */
  &[data-type="email"] {
    font-size: 0.85rem;
  }
`;

const DangerButton = styled.button`
  background: var(--danger);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
  justify-content: center;

  &:hover:not(:disabled) {
    background: var(--danger);
    transform: translateY(-1px);
    box-shadow: var(--shadow-sm);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const ConfirmationOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-popover); /* nad modalem klienta */
  backdrop-filter: blur(8px);
`;

const ConfirmationBox = styled.div`
  background: var(--card-bg);
  border: 2px solid var(--danger);
  border-radius: 16px;
  padding: 32px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: auto;
  text-align: center;
  box-shadow: var(--shadow-lg);
  animation: ${slideIn} 0.3s ease-out;
  position: relative;
`;

const ConfirmationTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--danger);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const ConfirmationText = styled.p`
  margin: 0 0 24px 0;
  color: var(--text);
  line-height: 1.6;
  font-size: 1rem;
  
  strong {
    color: var(--text);
    font-weight: 600;
  }
`;

const ConfirmationActions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
`;

const EditButton = styled.button`
  background: var(--primary);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
  justify-content: center;

  &:hover:not(:disabled) {
    background: var(--primary-hover);
    transform: translateY(-1px);
    box-shadow: var(--shadow-sm);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const EditOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-popover); /* nad modalem klienta */
  backdrop-filter: blur(8px);
`;

const EditBox = styled.div`
  background: var(--card-bg);
  border: 2px solid var(--primary);
  border-radius: 20px;
  padding: 32px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow: auto;
  box-shadow: var(--shadow-lg);
  animation: ${slideIn} 0.3s ease-out;
  position: relative;
`;

const EditTitle = styled.h3`
  margin: 0 0 24px 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
`;

const EditForm = styled.form`
  display: grid;
  gap: 20px;
`;

const EditField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const EditLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 8px;
`;

const EditInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid ${p => (p['data-error'] ? 'var(--danger)' : 'var(--input-border)')};
  border-radius: 12px;
  font-size: 14px;
  background: ${p => (p['data-error'] ? 'var(--danger-bg)' : 'var(--input-bg)')};
  color: var(--text);
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${p => (p['data-error'] ? 'var(--danger)' : 'var(--primary)')};
    box-shadow: var(--focus-ring);
  }

  /* Ujednolicone placeholdery (jaśniejsze + kursywa) dla edycji i dodawania */
  &::placeholder {
    color: var(--text-muted);
    opacity: 0.6;
    font-style: italic;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const AddInput = styled(EditInput)`
  &::placeholder {
    color: var(--text-muted);
    opacity: 0.6;
    font-style: italic;
  }
`;
const EditActions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--input-border);
`;

const Message = styled.div`
  margin-bottom: 20px;
  padding: 14px 18px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  background: ${props => props.error ? 'var(--danger-bg)' : 'var(--success-bg)'};
  color: ${props => props.error ? 'var(--danger)' : 'var(--success)'};
  border: 1px solid ${props => props.error ? 'var(--danger-border)' : 'var(--success-border)'};
  display: flex;
  align-items: center;
  gap: 10px;
`;

export default function ClientsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // W.5: UX-only gate (server enforces admin on the import endpoints) — reuses the
  // localStorage 'isAdmin' pattern from pages/profile.js.
  const isAdminUser = localStorage.getItem('isAdmin') === '1' || localStorage.getItem('isSuperAdmin') === '1';
  const [clients, setClients] = useState([]);
  const [q, setQ] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [filterBy, setFilterBy] = useState("all");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editError, setEditError] = useState("");
  const [addError, setAddError] = useState("");
  const [refreshToken, setRefreshToken] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedClient, setSelectedClient] = useState(null);
  
  // Stany dla usuwania
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportError, setExportError] = useState('');
  // Eksport kartoteki do pliku (26.10.2026), osobno od eksportu RODO jednego klienta wyżej.
  const [showListExport, setShowListExport] = useState(false);
  // Komunikat o nieudanym eksporcie dotyczy jednego klienta: nie przenosimy go na następnego.
  const selectedClientId = selectedClient?.id;
  useEffect(() => { setExportError(''); }, [selectedClientId]);

  // DODANE: Stany dla edycji
  const [showEditForm, setShowEditForm] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [editSuccess, setEditSuccess] = useState("");
  const [editFieldErrors, setEditFieldErrors] = useState({});
  const [editForm, setEditForm] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone_number: '',
    city: '',
    postal_code: '',
    street: '',
    building_number: '',
    apartment_number: '',
    client_type: 'private',
    company_name: '',
    company_nip: '',
    company_regon: ''
  });

  // DODANE: Stany dla dodawania klienta
  const [showAddForm, setShowAddForm] = useState(false); // DODANE
  const [addLoading, setAddLoading] = useState(false);
  const [addFieldErrors, setAddFieldErrors] = useState({});
  const [addForm, setAddForm] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone_number: '',
    city: '',
    postal_code: '',
    street: '',
    building_number: '',
    apartment_number: '',
    client_type: 'private',
    company_name: '',
    company_nip: '',
    company_regon: ''
  });

  const abortRef = useRef(null);
  const debounceRef = useRef(null);
  const errorTimerRef = useRef(null);

  const ITEMS_PER_PAGE = 9;
  // GET /api/clients bez parametru limit oddaje najwyżej 500 klientów; eksport bierze wszystkich
  // z serwera, więc przy pełnej liście okno eksportu podaje liczbę jako „500+”.
  const CLIENTS_LIST_LIMIT = 500;
  const ENDPOINT = `${API_BASE}/api/clients`;

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    const doFetch = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(ENDPOINT, { 
          signal: controller.signal,
          credentials: 'include'
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const payload = await res.json();
        // OBSŁUŻ: tablica lub wrapper { data: [...] }
        const list = Array.isArray(payload) ? payload : (payload?.data || []);

        const cleaned = list.filter(c => {
          const email = String(c.email || '').toLowerCase();
          const f = String(c.firstname || '').toLowerCase();
          const l = String(c.lastname || '').toLowerCase();
          return !(
            ((f === 'usunięty' || f === 'usuniety') && l === 'klient') ||
            email.endsWith('@x.invalid')
          );
        });

        setClients(cleaned);
      } catch (e) {
        if (e.name !== "AbortError") setError(e.message || 'Błąd połączenia');
      } finally {
        setLoading(false);
      }
    };

    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(doFetch, 300);

    return () => {
      controller.abort();
      clearTimeout(debounceRef.current);
    };
  }, [q, refreshToken]);

  // Filtrowanie i sortowanie
  const filtered = useMemo(() => {
    let result = [...clients];

    // Filtrowanie tekstowe
    if (q.trim()) {
      const term = q.trim().toLowerCase();
      result = result.filter(c =>
        [c.firstname, c.lastname, c.phone_number, c.email]
          .filter(Boolean)
          .some(v => String(v).toLowerCase().includes(term))
      );
    }

    // Filtrowanie po kategorii
    if (filterBy !== "all") {
      const now = new Date();
      const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
      
      switch (filterBy) {
        case "recent":
          result = result.filter(c => {
            const regDate = new Date(c.registration_date);
            return regDate >= oneMonthAgo;
          });
          break;
        case "frequent":
          result = result.filter(c => c.reservations_count >= 3);
          break;
        default:
          break;
      }
    }

    // Sortowanie
    result.sort((a, b) => {
      switch (sortBy) {
        case "name":
          return `${a.lastname} ${a.firstname}`.localeCompare(`${b.lastname} ${b.firstname}`);
        case "reservations":
          return (b.reservations_count || 0) - (a.reservations_count || 0);
        case "recent":
          return new Date(b.registration_date) - new Date(a.registration_date);
        default:
          return 0;
      }
    });

    return result;
  }, [clients, q, sortBy, filterBy]);

  // Podgląd eksportu „wszyscy klienci”: serwer oddaje ich w kolejności nazwisk, niezależnie od listy.
  const allClientsByName = useMemo(
    () => [...clients].sort((a, b) => `${a.lastname} ${a.firstname}`.localeCompare(`${b.lastname} ${b.firstname}`)),
    [clients]
  );

  // Paginacja
  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentClients = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  // Reset paginacji przy zmianie filtrów
  useEffect(() => {
    setCurrentPage(1);
  }, [q, sortBy, filterBy]);

  // Statystyki
  const stats = useMemo(() => {
    const total = clients.length;
    const newThisMonth = clients.filter(c => {
      const regDate = new Date(c.registration_date);
      const now = new Date();
      return regDate.getMonth() === now.getMonth() && regDate.getFullYear() === now.getFullYear();
    }).length;
    const frequentClients = clients.filter(c => c.reservations_count >= 3).length;

    return { total, newThisMonth, frequentClients };
  }, [clients]);

  const getClientInitials = (client) => {
    return `${client.firstname?.[0] || ''}${client.lastname?.[0] || ''}`.toUpperCase();
  };

  // Awatar dostaje ton wyliczony z ID klienta, nie zawsze ten sam --primary — inaczej lista
  // klientów to rząd identycznych niebieskich kwadratów z inicjałami. Ten sam klient dostaje
  // zawsze ten sam ton (stabilne id -> ton), więc kolor rozróżnia wiersze, a nie miga między
  // odświeżeniami. Wzorzec znany z awatarów Slacka/Gmaila, nie losowość dla samej losowości.
  const getClientTone = (client) => {
    const key = String(client?.id ?? `${client?.firstname || ''}${client?.lastname || ''}`);
    let hash = 0;
    for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    return CLIENT_AVATAR_TONES[hash % CLIENT_AVATAR_TONES.length];
  };

  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString('pl-PL', {
        year: 'numeric',
        month: 'short'
      });
    } catch {
      return '-';
    }
  };

  // POPRAWIONA funkcja do tworzenia nowej rezerwacji
  const handleNewReservation = (client) => {
    const isReal = v => v !== null && typeof v !== 'undefined' && String(v).trim() !== '' && String(v).trim().toLowerCase() !== 'brak danych';

    const clientData = {};
    if (isReal(client.firstname)) clientData.firstname = client.firstname;
    if (isReal(client.lastname))  clientData.lastname  = client.lastname;
    if (isReal(client.email))     clientData.email     = client.email;
    if (isReal(client.phone_number)) clientData.phone_number = client.phone_number;
    if (isReal(client.city))         clientData.city = client.city;
    if (isReal(client.postal_code))  clientData.postal_code = client.postal_code;
    if (isReal(client.street))       clientData.street = client.street;
    if (isReal(client.building_number)) clientData.building_number = client.building_number;
    if (isReal(client.apartment_number)) clientData.apartment_number = client.apartment_number;

    // DOŁĄCZ ID klienta (jeśli jest) — to kluczowe dla bezbłędnego mapowania
    if (client.id) clientData.client_id = client.id;

    localStorage.setItem('prefillClientData', JSON.stringify(clientData));
    setSelectedClient(null);
    navigate('/reservation');
  };

  // NOWE: przejście do kalendarza -> historia z filtrem po nazwie klienta
  const viewClientReservations = (client) => {
    if (!client) return;
    const name = `${client.firstname || ''} ${client.lastname || ''}`.trim();
    setSelectedClient(null);
    navigate(`/calendar?tab=history&name=${encodeURIComponent(name)}`);
  };

  // S.3: eksport danych osobowych klienta (art. 15/20 RODO) jako plik JSON. Serwer wpuszcza
  // tylko administratora; przycisk pokazujemy tylko jemu, żeby pracownik nie trafiał na 403.
  const handleExportClient = async () => {
    if (!selectedClient) return;
    setExportLoading(true);
    setExportError('');
    try {
      const response = await fetch(`${ENDPOINT}/${selectedClient.id}/export`, { credentials: 'include' });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || data.message || t('clients.exportFailed'));
      }
      const blob = await response.blob();
      const naglowek = response.headers.get('content-disposition') || '';
      const nazwa = (naglowek.match(/filename="([^"]+)"/) || [])[1] || `client-${selectedClient.id}.json`;
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nazwa;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      setExportError(err.message || t('clients.exportFailed'));
    } finally {
      setExportLoading(false);
    }
  };

  // DODANE: Funkcja do usuwania klienta
  const handleDeleteClient = async () => {
    if (!selectedClient) return;

    setDeleteLoading(true);
    setError("");

    try {
      const csrf = localStorage.getItem('csrfToken') || '';
      const response = await fetch(`${ENDPOINT}/${selectedClient.id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
        credentials: 'include'
      });

      if (!response.ok) {
        let msg = 'Nie można usunąć klienta';
        try {
          const ct = response.headers.get('content-type') || '';
          if (ct.includes('application/json')) {
            const data = await response.json();
            if (data && data.message) msg = data.message;
            else if (typeof data === 'string') msg = data;
            else msg = JSON.stringify(data);
          } else {
            const text = await response.text();
            if (text) msg = text;
          }
        } catch (e) {
          // leave default msg
        }
        throw new Error(msg);
      }

      // 1) Odśwież listę
      setRefreshToken(t => t + 1);

      // 2) Zamknij okna i wyczyść stan
      setShowDeleteConfirmation(false);
      setSelectedClient(null);

      // 3) Wróć na stronę klientów i przewiń do góry
      navigate('/clients', { replace: true });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      // clear any existing timer
      try { if (errorTimerRef.current) { clearTimeout(errorTimerRef.current); errorTimerRef.current = null; } } catch(e){}
      const msg = err.message || 'Wystąpił błąd podczas usuwania klienta';
      setError(msg);
      // zamknij panel szczegółów i potwierdzenia, przewiń do góry
      try { setSelectedClient(null); } catch (e) {}
      try { setShowDeleteConfirmation(false); } catch (e) {}
      try { scrollToTop(); } catch (e) {}
      // usuń komunikat po 5 sekundach
      try { errorTimerRef.current = setTimeout(() => setError(''), 5000); } catch(e){}
    } finally {
      setDeleteLoading(false);
    }
  };

  // DODANE: Funkcja do anulowania usuwania
  const handleCancelDelete = () => {
    setShowDeleteConfirmation(false);
    setDeleteLoading(false);
  };

  // DODANE: Funkcje do edycji klienta
  const handleEditClient = (client) => {
    setEditForm({
      firstname: client.firstname || '',
      lastname: client.lastname || '',
      email: client.email || '',
      phone_number: client.phone_number || '',
      city: client.city || '',
      postal_code: client.postal_code || '',
      street: client.street || '',
      building_number: client.building_number || '',
      apartment_number: client.apartment_number || '',
      client_type: client.client_type || 'private',
      company_name: client.company_name || '',
      company_nip: client.company_nip || '',
      company_regon: client.company_regon || ''
    });
    setShowEditForm(true);
    setError("");
    setEditError("");
    setEditFieldErrors({});
    setEditSuccess("");
  };

  const handleEditFormChange = (field, value) => {
    setEditForm(prev => ({
      ...prev,
      [field]: value
    }));
    setEditFieldErrors(prev => ({ ...prev, [field]: false }));
    setEditError('');
  };

  const handleEditFormSubmit = async (e) => {
    e.preventDefault();
    if (!selectedClient) return;

    setEditLoading(true);
    setEditError("");
    setEditFieldErrors({});

    // Front validation
    const requiredErrors = {};
    if (!editForm.firstname.trim()) requiredErrors.firstname = true;
    if (!editForm.lastname.trim()) requiredErrors.lastname = true;
    if (Object.keys(requiredErrors).length) {
      setEditFieldErrors(requiredErrors);
      setEditError('Uzupełnij wymagane pola, aby kontynuować.');
      scrollToTop();
      setEditLoading(false);
      return;
    }

    try {
      const csrf = localStorage.getItem('csrfToken') || '';
      const response = await fetch(`${ENDPOINT}/${selectedClient.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrf
        },
        credentials: 'include',
        body: JSON.stringify(editForm)
      });

      if (!response.ok) {
        const errorData = await response.text();
        const lower = (errorData || '').toLowerCase();
        const errors = {};
        if (/imi|first/.test(lower)) errors.firstname = true;
        if (/nazw|last/.test(lower)) errors.lastname = true;
        if (/email/.test(lower)) errors.email = true;
        if (/telefon|phone/.test(lower)) errors.phone_number = true;
        setEditFieldErrors(errors);
        setEditError(errorData || `Błąd ${response.status}: Nie można zaktualizować danych klienta`);
        scrollToTop();
        throw new Error(errorData || `Błąd ${response.status}`);
      }

      const updatedClient = await response.json();

      // Sukces
      setEditSuccess(`Dane klienta zostały pomyślnie zaktualizowane`);
      setEditError('');
      setEditFieldErrors({});
      
      // Zaktualizuj wybranego klienta
      setSelectedClient(updatedClient);
      
      // Odśwież listę klientów
      setRefreshToken(t => t + 1);
      
      // Zamknij formularz edycji po krótkim opóźnieniu
      setTimeout(() => {
        setShowEditForm(false);
        setEditSuccess("");
      }, 1500);

    } catch (err) {
      if (!err?.message?.includes('Błąd')) {
        // jeśli błąd nie został już ustawiony wyżej
        setEditError(err.message || 'Wystąpił błąd podczas aktualizacji danych klienta');
        scrollToTop();
      }
    } finally {
      setEditLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setShowEditForm(false);
    setEditLoading(false);
    setError("");
    setEditError("");
    setEditFieldErrors({});
    setEditSuccess("");
  };

  // DODANE: Funkcje do dodawania klienta
  const handleOpenAdd = () => {
    setAddForm({
      firstname: '',
      lastname: '',
      email: '',
      phone_number: '',
      city: '',
      postal_code: '',
      street: '',
      building_number: '',
      apartment_number: '',
      client_type: 'private',
      company_name: '',
      company_nip: '',
      company_regon: ''
    });
    setShowAddForm(true);
    setError('');
    setAddError('');
    setAddFieldErrors({});
    setEditSuccess('');
  };

  const handleAddChange = (field, value) => {
    setAddForm(prev => ({ ...prev, [field]: value }));
    setAddFieldErrors(prev => ({ ...prev, [field]: false }));
    setAddError('');
  };

  // helper: spróbuj znaleźć klienta po email (próby: /api/clients/search, /api/clients?email=..., fallback: /api/clients)
  const findClientByEmail = async (email) => {
    if (!email) return null;
    const q = encodeURIComponent(email.trim().toLowerCase());
    // 1) próbuj endpointu /search jeśli istnieje
    try {
      const r = await fetch(`${ENDPOINT}/search?query=${q}`, { credentials: 'include' });
      if (r.ok) {
        const payload = await r.json();
        const list = Array.isArray(payload) ? payload : (payload?.data || []);
        const exact = list.find(c => c.email && String(c.email).toLowerCase() === email.toLowerCase());
        if (exact) return exact;
      }
    } catch (e) { /* ignore */ }

    // 2) próbuj /api/clients?email=...
    try {
      const r2 = await fetch(`${ENDPOINT}?email=${q}`, { credentials: 'include' });
      if (r2.ok) {
        const payload = await r2.json();
        const list = Array.isArray(payload) ? payload : (payload?.data || []);
        const exact = list.find(c => c.email && String(c.email).toLowerCase() === email.toLowerCase());
        if (exact) return exact;
      }
    } catch (e) { /* ignore */ }

    // 3) fallback: pobierz wszystkich i znajdź po email
    try {
      const r3 = await fetch(ENDPOINT, { credentials: 'include' });
      if (r3.ok) {
        const payload = await r3.json();
        const list = Array.isArray(payload) ? payload : (payload?.data || []);
        return list.find(c => c.email && String(c.email).toLowerCase() === email.toLowerCase()) || null;
      }
    } catch (e) { /* ignore */ }

    return null;
  };

  const handleAddSubmit = async (e) => {
    e && e.preventDefault();
    setAddLoading(true);
    setAddError('');
    setAddFieldErrors({});

    const requiredErrors = {};
    if (!addForm.firstname.trim()) requiredErrors.firstname = true;
    if (!addForm.lastname.trim()) requiredErrors.lastname = true;
    if (Object.keys(requiredErrors).length) {
      setAddFieldErrors(requiredErrors);
      setAddError('Uzupełnij wymagane pola, aby kontynuować.');
      scrollToTop();
      setAddLoading(false);
      return;
    }

    try {
      // spróbuj utworzyć klienta
      const csrf = localStorage.getItem('csrfToken') || '';
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: {'Content-Type':'application/json', 'X-CSRF-Token': csrf},
        body: JSON.stringify(addForm),
        credentials: 'include'
      });

      if (res.ok) {
        const created = await res.json();
        setRefreshToken(t => t + 1);
        setShowAddForm(false);
        setSelectedClient(created);
        navigate('/clients', { replace: true });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      // obsłuż przypadek duplicate key / conflict
      const text = await res.text().catch(() => '');
      // jeśli serwer zwróci status 409 lub tekst zawiera "duplicate" -> spróbuj znaleźć istniejącego klienta
      if (res.status === 409 || /duplicate|unique|already exists/i.test(text)) {
        const existing = await findClientByEmail(addForm.email);
        if (existing) {
          // użyj istniejącego klienta zamiast powodować błąd
          setRefreshToken(t => t + 1);
          setShowAddForm(false);
          setSelectedClient(existing);
          navigate('/clients', { replace: true });
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
      }

      // w pozostałych przypadkach zgłoś błąd
      throw new Error(text || `HTTP ${res.status}`);
    } catch (err) {
      const lower = (err.message || '').toLowerCase();
      const errors = {};
      if (/imi|first/.test(lower)) errors.firstname = true;
      if (/nazw|last/.test(lower)) errors.lastname = true;
      if (/email/.test(lower)) errors.email = true;
      if (/telefon|phone/.test(lower)) errors.phone_number = true;
      setAddFieldErrors(errors);
      setAddError(err.message || 'Błąd podczas dodawania klienta');
      scrollToTop();
    } finally {
      setAddLoading(false);
    }
  };

  useEffect(() => {
    const onClientsUpdated = () => {
      // np. wywołaj funkcję przeładowującą listę klientów lub zaktualizuj token odświeżenia
      // fetchClients(); // <- jeśli masz taką funkcję
      setRefreshToken?.(t => (t || 0) + 1); // <- jeśli używasz stanu refreshToken
      // lub: window.location.reload();  // ostrożnie — przeładuje całą stronę
    };

    window.addEventListener('clients:updated', onClientsUpdated);
    return () => window.removeEventListener('clients:updated', onClientsUpdated);
  }, []);

  // cleanup for error timer
  useEffect(() => {
    return () => {
      try { if (errorTimerRef.current) clearTimeout(errorTimerRef.current); } catch (e) {}
    };
  }, []);

  return (
    <LocalContainer>
      {/* Header */}
      <HeaderRow>
        <TitleSection>
          <Title>{t('clients.title')}</Title>
          <Subtitle>
            {t('clients.subtitle')}
          </Subtitle>
        </TitleSection>
        <ActionButtons>
          <PrimaryButton 
            onClick={() => setRefreshToken(t => t + 1)}
            disabled={loading}
          >
            <RefreshIcon />
            Odśwież
          </PrimaryButton>
          {/* Eksport tylko dla administratora (serwer i tak to sprawdza): to dane osobowe
              wszystkich klientów naraz, jak eksport RODO jednego klienta. */}
          {isAdminUser && (
            <SecondaryButton
              onClick={() => setShowListExport(true)}
              disabled={loading || clients.length === 0}
              data-cy="clients-open-export"
            >
              <DownloadIcon />
              {t('clientsExport.open')}
            </SecondaryButton>
          )}
          <PrimaryButton onClick={handleOpenAdd} disabled={loading} data-cy="clients-open-add">
            <PlusIcon />
            Dodaj klienta
          </PrimaryButton>
        </ActionButtons>
      </HeaderRow>

      {/* Statystyki */}
      <StatsGrid>
        <StatCard>
          <StatIcon $tone="steel">
            <UserIcon />
          </StatIcon>
          <StatContent>
            <StatValue>{stats.total}</StatValue>
            <StatLabel>Wszyscy klienci</StatLabel>
          </StatContent>
        </StatCard>

        <StatCard>
          <StatIcon $tone="dusk">
            <CalendarIcon />
          </StatIcon>
          <StatContent>
            <StatValue>{stats.newThisMonth}</StatValue>
            <StatLabel>{t('clients.newThisMonth')}</StatLabel>
          </StatContent>
        </StatCard>

        <StatCard>
          <StatIcon $tone="gold">
            <TrendingUpIcon />
          </StatIcon>
          <StatContent>
            <StatValue>{stats.frequentClients}</StatValue>
            <StatLabel>Stali klienci (3+)</StatLabel>
          </StatContent>
        </StatCard>
      </StatsGrid>

      {/* Narzędzia */}
      <Card>
        <ToolbarSection>
          {/* data-tour: kotwica mini-przewodnika strony (utils/pageTours.js) */}
          <SearchContainer data-tour="clients-search">
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <SearchInput
              value={q}
              onChange={e => setQ(e.target.value)}
              placeholder="Szukaj po nazwisku, imieniu, telefonie lub emailu..."
            />
          </SearchContainer>

          <FilterRow>
            <FilterDropdown
              value={sortBy}
              onChange={setSortBy}
              options={[
                { value: 'name', label: 'A-Z' },
                { value: 'reservations', label: 'Rezerwacje' },
                { value: 'recent', label: 'Najnowsi' }
              ]}
            />

            <FilterDropdown
              value={filterBy}
              onChange={setFilterBy}
              options={[
                { value: 'all', label: 'Wszyscy klienci' },
                { value: 'recent', label: 'Nowi (30 dni)' },
                { value: 'frequent', label: 'Stali klienci (3+)' }
              ]}
            />
          </FilterRow>
        </ToolbarSection>

        {error && (
          <ErrorMessage>
            <AlertTriangleIcon /> {error}
          </ErrorMessage>
        )}

        <div style={{ 
          fontSize: '14px', 
          color: 'var(--text-muted)', 
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>
            {t('clients.shownOfTotal', { shown: filtered.length, total: clients.length })}
          </span>
          {q && (
            <span>
              Wyniki dla: "<strong>{q}</strong>"
            </span>
          )}
        </div>
      </Card>

      {/* Lista klientów */}
      <Card>
        {loading ? (
          <LoadingState>
            Ładowanie klientów...
          </LoadingState>
        ) : currentClients.length > 0 ? (
          <>
            <ClientGrid>
              {currentClients.map((client, i) => (
                <ClientCard 
                  key={client.id}
                  data-tour={i === 0 ? 'clients-card' : undefined}
                  onClick={() => setSelectedClient(client)}
                >
                  <ClientHeader>
                    <ClientAvatar $tone={getClientTone(client)}>
                      {getClientInitials(client)}
                    </ClientAvatar>
                    <div style={{ flex: 1 }}>
                      <ClientName>
                        {client.firstname} {client.lastname}
                      </ClientName>
                    </div>
                    <ViewMoreButton
                      aria-label={`${t('clients.showDetails')}: ${client.firstname} ${client.lastname}`}
                      title={t('clients.showDetails')}
                      onClick={(e) => {
                      e.stopPropagation();
                      setSelectedClient(client);
                    }}>
                      <ExternalLinkIcon />
                    </ViewMoreButton>
                  </ClientHeader>

                  <ClientInfo>
                    <InfoRow>
                      <MailIcon />
                      {client.email?.trim() || 'Brak danych'}
                    </InfoRow>
                    <InfoRow>
                      <PhoneIcon />
                      {client.phone_number?.trim() || 'Brak danych'}
                    </InfoRow>
                  </ClientInfo>

                  <ClientStats>
                    <ReservationsBadge>
                      <TrendingUpIcon />
                      Liczba rezerwacji: {client.reservations_count || 0}
                    </ReservationsBadge>
                    <JoinDate>
                      <CalendarIcon />
                      {formatDate(client.registration_date)}
                    </JoinDate>
                  </ClientStats>
                </ClientCard>
              ))}
            </ClientGrid>

            {/* Paginacja */}
            {totalPages > 1 && (
              <Pagination>
                <SecondaryButton
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                >
                  Poprzednia
                </SecondaryButton>

                <PageInfo>
                  Strona {currentPage} z {totalPages}
                </PageInfo>

                <SecondaryButton
                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                >
                  Następna
                </SecondaryButton>
              </Pagination>
            )}
          </>
        ) : (
          <EmptyState>
            <EmptyIcon><UsersIcon size={56} /></EmptyIcon>
            <EmptyTitle>
              {q ? 'Brak wyników wyszukiwania' : 'Brak klientów'}
            </EmptyTitle>
            <EmptyText>
              {q
                ? `Nie znaleziono klientów pasujących do "${q}". Spróbuj zmienić kryteria wyszukiwania.`
                : 'Klienci będą automatycznie dodawani podczas tworzenia nowych rezerwacji.'
              }
            </EmptyText>
            {!q && (
              <>
                <EmptyText style={{ marginTop: '4px' }}>{t('clients.emptyState.hint')}</EmptyText>
                <div style={{ marginTop: '12px', display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <PrimaryButton data-cy="clients-empty-add-button" onClick={handleOpenAdd}>
                    {t('clients.addClient')}
                  </PrimaryButton>
                  {isAdminUser && (
                    <SecondaryButton data-cy="clients-import-button" onClick={() => navigate('/import?entity=clients')}>
                      {t('clients.importFromFile')}
                    </SecondaryButton>
                  )}
                </div>
              </>
            )}
          </EmptyState>
        )}
      </Card>

      {/* Modal szczegółów klienta */}
      {selectedClient && (
        <Modal onClick={() => !showDeleteConfirmation && !showEditForm && setSelectedClient(null)}>
          <ModalContent onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
            <ModalHeader>
              <ModalTitle>
                Szczegóły klienta
              </ModalTitle>
              <CloseButton 
                onClick={() => !showDeleteConfirmation && !showEditForm && setSelectedClient(null)}
                disabled={showDeleteConfirmation || showEditForm}
              >
                ×
              </CloseButton>
            </ModalHeader>

            <div style={{ marginBottom: '24px', textAlign: 'center' }}>
              <IconBadge
                $size={80}
                $tone={getClientTone(selectedClient)}
                style={{ fontSize: '1.75rem', fontWeight: '700', margin: '0 auto 16px' }}
              >
                {getClientInitials(selectedClient)}
              </IconBadge>
              <h3 style={{ margin: '0 0 8px 0', fontSize: '1.5rem', fontWeight: '600' }}>
                {selectedClient.firstname} {selectedClient.lastname}
              </h3>
              <div style={{ 
                background: 'var(--success)',
                color: 'white',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '600'
              }}>
                <TrendingUpIcon />
                Liczba rezerwacji: {selectedClient.reservations_count || 0}
              </div>
            </div>

            <DetailGrid>
              <DetailItem>
                <DetailLabel>{t('clients.name')}</DetailLabel>
                <DetailValue>{selectedClient.firstname} {selectedClient.lastname}</DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>Email</DetailLabel>
                <DetailValue data-type="email">{selectedClient.email?.trim() || 'Brak danych'}</DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>Telefon</DetailLabel>
                <DetailValue>{selectedClient.phone_number?.trim() || 'Brak danych'}</DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>Adres</DetailLabel>
                <DetailValue style={{ wordWrap: 'break-word', lineHeight: '1.4' }}>
                  {(() => {
                    const street = selectedClient.street || null;
                    const bld = selectedClient.building_number ? String(selectedClient.building_number) : null;
                    const apt = selectedClient.apartment_number ? String(selectedClient.apartment_number) : null;
                    const buildingPart = bld ? (apt ? `${bld}/${apt}` : bld) : null;
                    const postal = selectedClient.postal_code || null;
                    const city = selectedClient.city || null;
                    const parts = [street, buildingPart, postal, city].filter(Boolean);
                    return parts.length ? parts.join(', ') : 'Brak danych';
                  })()}
                </DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>Data rejestracji</DetailLabel>
                <DetailValue>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <CalendarIcon />
                    {formatDate(selectedClient.registration_date)}
                  </div>
                </DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>ID klienta</DetailLabel>
                <DetailValue>#{selectedClient.id}</DetailValue>
              </DetailItem>

              <DetailItem>
                <DetailLabel>Status</DetailLabel>
                <DetailValue>
                  <div style={{ 
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '8px 12px',
                    borderRadius: '12px',
                    background: selectedClient.reservations_count >= 3
                      ? 'var(--success)'
                      : 'var(--primary)',
                    color: 'var(--primary-contrast)',
                    fontSize: '0.8rem',
                    fontWeight: '600'
                  }}>
                    {selectedClient.reservations_count >= 3
                      ? <><StarIcon size={14} /> {t('clients.regularClient')}</>
                      : <><UserIcon /> Klient</>}
                  </div>
                </DetailValue>
              </DetailItem>
            </DetailGrid>

            {/* Sekcja statystyk klienta */}
            <div style={{ 
              marginTop: '24px',
              padding: '20px',
              background: 'var(--input-bg)',
              borderRadius: '12px',
              border: '1px solid var(--input-border)'
            }}>
              <h4 style={{ 
                margin: '0 0 16px 0', 
                fontSize: '1rem', 
                fontWeight: '600', 
                color: 'var(--text)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <TrendingUpIcon />
                Statystyki klienta
              </h4>
              
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', 
                gap: '16px' 
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: '700', 
                    color: 'var(--text)',
                    marginBottom: '4px'
                  }}>
                    {selectedClient.reservations_count || 0}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                    Rezerwacji
                  </div>
                </div>
                
                <div style={{ textAlign: 'center' }}>
                  <div style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: '700', 
                    color: 'var(--text)',
                    marginBottom: '4px'
                  }}>
                    {(() => {
                      const regDate = new Date(selectedClient.registration_date);
                      const now = new Date();
                      const diffTime = Math.abs(now - regDate);
                      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                      return diffDays;
                    })()}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                    Dni z nami
                  </div>
                </div>

                <div style={{ textAlign: 'center' }}>
                  <div style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: '700', 
                    color: 'var(--text)',
                    marginBottom: '4px'
                  }}>
                    {selectedClient.reservations_count > 0 
                      ? (selectedClient.reservations_count / Math.max(1, Math.ceil((new Date() - new Date(selectedClient.registration_date)) / (1000 * 60 * 60 * 24 * 30)))).toFixed(1)
                      : '0'
                    }
                  </div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                    Rez./miesiąc
                  </div>
                </div>
              </div>
            </div>

            <div style={{ 
              marginTop: '24px',
              display: 'flex',
              justifyContent: 'space-between',
              gap: '12px',
              flexWrap: 'wrap'
            }}>
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                <PrimaryButton 
                  onClick={() => handleNewReservation(selectedClient)}
                  disabled={showDeleteConfirmation || showEditForm}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2v20M2 12h20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  Nowa rezerwacja
                </PrimaryButton>

                {/* ZMIANA: wyróżniony przycisk Rezerwacje klienta */}
                <ReservationsButton
                  onClick={() => viewClientReservations(selectedClient)}
                  disabled={showDeleteConfirmation || showEditForm}
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <CalendarIcon />
                  Rezerwacje
                </ReservationsButton>
                
                <EditButton 
                  onClick={() => handleEditClient(selectedClient)}
                  disabled={showDeleteConfirmation || showEditForm || deleteLoading}
                >
                  <EditIcon />
                  Edytuj dane
                </EditButton>

                {isAdminUser && (
                  <SecondaryButton
                    data-cy="client-export-button"
                    onClick={handleExportClient}
                    disabled={showDeleteConfirmation || showEditForm || exportLoading}
                    title={t('clients.exportDataHint')}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                  >
                    <DownloadIcon />
                    {exportLoading ? t('clients.exportLoading') : t('clients.exportData')}
                  </SecondaryButton>
                )}

                {/* S.4: usuwa tylko administrator (serwer odpowiada 403 pracownikowi). */}
                {isAdminUser && (
                  <DangerButton
                    onClick={() => setShowDeleteConfirmation(true)}
                    disabled={showDeleteConfirmation || showEditForm || deleteLoading}
                  >
                    <TrashIcon />
                    Usuń klienta
                  </DangerButton>
                )}
                {exportError && (
                  <div role="alert" data-cy="client-export-error" style={{ flexBasis: '100%', color: 'var(--danger)', fontSize: '0.88rem' }}>
                    {exportError}
                  </div>
                )}
              </div>
              
              <SecondaryButton 
                onClick={() => setSelectedClient(null)}
                disabled={showDeleteConfirmation || showEditForm}
              >
                Zamknij
              </SecondaryButton>
            </div>
          </ModalContent>
        </Modal>
      )}

      {/* DODANE: Overlay z formularzem edycji */}
      {showEditForm && selectedClient && (
        <EditOverlay onClick={handleCancelEdit}>
          <EditBox onClick={e => e.stopPropagation()}>
            
            {/* Komunikaty edycji */}
            {editSuccess && (
              <Message>
                {editSuccess}
              </Message>
            )}

            {editError && (
              <Message error>
                <AlertTriangleIcon /> {editError}
              </Message>
            )}

            <EditTitle>
              <EditIcon />
              Edycja danych klienta
            </EditTitle>

            <EditForm onSubmit={handleEditFormSubmit} noValidate>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
                gap: '20px' 
              }}>
                <EditField>
                  <EditLabel>
                    <UserIcon />
                    Imię *
                  </EditLabel>
                  <EditInput
                    type="text"
                    value={editForm.firstname}
                    onChange={e => handleEditFormChange('firstname', e.target.value)}
                    placeholder={t('clients.firstNamePlaceholder')}
                    required
                    disabled={editLoading}
                    maxLength={50}
                    data-error={!!editFieldErrors.firstname}
                  />
                </EditField>

                <EditField>
                  <EditLabel>
                    <UserIcon />
                    Nazwisko *
                  </EditLabel>
                  <EditInput
                    type="text"
                    value={editForm.lastname}
                    onChange={e => handleEditFormChange('lastname', e.target.value)}
                    placeholder="Wpisz nazwisko"
                    required
                    disabled={editLoading}
                    maxLength={50}
                    data-error={!!editFieldErrors.lastname}
                  />
                </EditField>

                <EditField>
                  <EditLabel>
                    <MailIcon />
                    Email
                  </EditLabel>
                  <EditInput
                    type="email"
                    autoComplete="email"
                    data-cy="clients-edit-email"
                    value={editForm.email}
                    onChange={e => handleEditFormChange('email', e.target.value)}
                    placeholder={t('clients.emailPlaceholder')}
                    disabled={editLoading}
                    maxLength={100}
                    data-error={!!editFieldErrors.email}
                  />
                </EditField>

                <EditField>
                  <EditLabel>
                    <PhoneIcon />
                    Telefon
                  </EditLabel>
                  <EditInput
                    type="tel"
                    value={editForm.phone_number}
                    onChange={e => handleEditFormChange('phone_number', e.target.value)}
                    placeholder="+48 123 456 789"
                    disabled={editLoading}
                    maxLength={20}
                    data-error={!!editFieldErrors.phone_number}
                  />
                </EditField>

                {/* PRZENIESIONE: Pole adres usunięte z edycji (korzystamy z rozbitych pól adresowych) */}

                {/* Nowe pola adresowe */}
                <EditField>
                  <EditLabel>Miasto</EditLabel>
                  <EditInput
                    value={editForm.city}
                    onChange={e => handleEditFormChange('city', e.target.value)}
                    placeholder="Warszawa"
                  />
                </EditField>
                <EditField>
                  <EditLabel>Kod pocztowy</EditLabel>
                  <EditInput
                    value={editForm.postal_code}
                    onChange={e => handleEditFormChange('postal_code', e.target.value)}
                    placeholder="00-000"
                  />
                </EditField>
                <EditField>
                  <EditLabel>Ulica</EditLabel>
                  <EditInput
                    value={editForm.street}
                    onChange={e => handleEditFormChange('street', e.target.value)}
                    placeholder="Polna"
                  />
                </EditField>
                <EditField>
                  <EditLabel>Nr budynku</EditLabel>
                  <EditInput
                    value={editForm.building_number}
                    onChange={e => handleEditFormChange('building_number', e.target.value)}
                    placeholder="12"
                  />
                </EditField>
                <EditField>
                  <EditLabel>Nr lokalu</EditLabel>
                  <EditInput
                    value={editForm.apartment_number}
                    onChange={e => handleEditFormChange('apartment_number', e.target.value)}
                    placeholder="3A"
                  />
                </EditField>
              </div>

              {/* Typ klienta + pola firmowe (do faktur) */}
              <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid var(--input-border)' }}>
                <div style={{ display: 'flex', gap: 20, marginBottom: 14, alignItems: 'center' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
                    <input
                      type="radio"
                      name="edit_client_type"
                      value="private"
                      checked={editForm.client_type !== 'company'}
                      onChange={() => handleEditFormChange('client_type', 'private')}
                    />
                    Osoba prywatna
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
                    <input
                      type="radio"
                      name="edit_client_type"
                      value="company"
                      checked={editForm.client_type === 'company'}
                      onChange={() => handleEditFormChange('client_type', 'company')}
                    />
                    Firma
                  </label>
                </div>
                {editForm.client_type === 'company' && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
                    <EditField>
                      <EditLabel>Nazwa firmy *</EditLabel>
                      <EditInput
                        value={editForm.company_name}
                        onChange={e => handleEditFormChange('company_name', e.target.value)}
                        placeholder="Firma Sp. z o.o."
                      />
                    </EditField>
                    <EditField>
                      <EditLabel>NIP *</EditLabel>
                      <EditInput
                        value={editForm.company_nip}
                        onChange={e => handleEditFormChange('company_nip', e.target.value)}
                        placeholder="1234567890"
                        maxLength={20}
                      />
                    </EditField>
                    <EditField>
                      <EditLabel>REGON (opcjonalnie)</EditLabel>
                      <EditInput
                        value={editForm.company_regon}
                        onChange={e => handleEditFormChange('company_regon', e.target.value)}
                        placeholder="123456789"
                        maxLength={20}
                      />
                    </EditField>
                  </div>
                )}
              </div>

              <EditActions>
                <SecondaryButton 
                  type="button"
                  onClick={handleCancelEdit}
                  disabled={editLoading}
                  style={{ minWidth: '120px' }}
                >
                  <XIcon /> Anuluj
                </SecondaryButton>
                
                <EditButton 
                  type="submit"
                  disabled={editLoading || !editForm.firstname.trim() || !editForm.lastname.trim()}
                  style={{ minWidth: '120px' }}
                >
                  {editLoading ? (
                    <>
                      <div style={{ 
                        width: '16px', 
                        height: '16px', 
                        border: '2px solid transparent',
                        borderTop: '2px solid white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }} />
                      Zapisywanie...
                    </>
                  ) : (
                    <>
                      Zapisz zmiany
                    </>
                  )}
                </EditButton>
              </EditActions>
            </EditForm>
          </EditBox>
        </EditOverlay>
      )}

      {/* DODANE: Overlay z formularzem dodawania klienta */}
      {showAddForm && (
        <EditOverlay onClick={() => setShowAddForm(false)} data-cy="clients-add-overlay">
          <EditBox onClick={e => e.stopPropagation()}>
            <EditTitle>
              <UserIcon /> Dodaj nowego klienta
            </EditTitle>

            {addError && (
              <Message error>
                <AlertTriangleIcon /> {addError}
              </Message>
            )}

            {/* noValidate (przegląd PR #214): pole e-mail ma type="email" dla klawiatury dotykowej,
                ale walidacja przeglądarki blokowała zapis adresu z polską literą („józef@poczta.pl”)
                dymkiem zamiast komunikatów formularza, choć API i widget przyjmują taki adres. Pola
                sprawdza handleAddSubmit. Typ zostaje „email” jak w Nowej rezerwacji, edycji
                rezerwacji, ofercie i widgecie: Chrome zapisuje polską domenę w takim polu jako
                punycode, więc pole tekstowe tylko tutaj dawałoby dla tego samego adresu inny tekst
                niż pozostałe formularze i dopasowanie klienta po e-mailu zakładałoby drugiego. */}
            <EditForm onSubmit={handleAddSubmit} noValidate>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
                <EditField>
                  <EditLabel>{t('clients.firstNameRequired')}</EditLabel>
                  <AddInput value={addForm.firstname} onChange={e=>handleAddChange('firstname', e.target.value)} placeholder="Jan" data-error={!!addFieldErrors.firstname} data-cy="clients-add-firstname"/>
                </EditField>
                <EditField>
                  <EditLabel>Nazwisko*</EditLabel>
                  <AddInput value={addForm.lastname} onChange={e=>handleAddChange('lastname', e.target.value)} placeholder="Kowalski" data-error={!!addFieldErrors.lastname} data-cy="clients-add-lastname"/>
                </EditField>
                <EditField>
                  <EditLabel>Email</EditLabel>
                  <AddInput type="email" autoComplete="email" value={addForm.email} onChange={e=>handleAddChange('email', e.target.value)} placeholder="email@domena.pl" data-error={!!addFieldErrors.email} data-cy="clients-add-email"/>
                </EditField>
                <EditField>
                  <EditLabel>Telefon</EditLabel>
                  <AddInput type="tel" value={addForm.phone_number} onChange={e=>handleAddChange('phone_number', e.target.value)} placeholder="+48 600 700 800" data-error={!!addFieldErrors.phone_number} data-cy="clients-add-phone"/>
                </EditField>

                {/* Nowe pola adresowe */}
                <EditField>
                  <EditLabel>Miasto</EditLabel>
                  <AddInput value={addForm.city} onChange={e=>handleAddChange('city', e.target.value)} placeholder="Warszawa"/>
                </EditField>
                <EditField>
                  <EditLabel>Kod pocztowy</EditLabel>
                  <AddInput value={addForm.postal_code} onChange={e=>handleAddChange('postal_code', e.target.value)} placeholder="00-000"/>
                </EditField>
                <EditField>
                  <EditLabel>Ulica</EditLabel>
                  <AddInput value={addForm.street} onChange={e=>handleAddChange('street', e.target.value)} placeholder="Polna"/>
                </EditField>
                <EditField>
                  <EditLabel>Nr budynku</EditLabel>
                  <AddInput value={addForm.building_number} onChange={e=>handleAddChange('building_number', e.target.value)} placeholder="12"/>
                </EditField>
                <EditField>
                  <EditLabel>Nr lokalu</EditLabel>
                  <AddInput value={addForm.apartment_number} onChange={e=>handleAddChange('apartment_number', e.target.value)} placeholder="3A"/>
                </EditField>
              </div>

              {/* Typ klienta + pola firmowe (do faktur) */}
              <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid var(--input-border)' }}>
                <div style={{ display: 'flex', gap: 20, marginBottom: 14, alignItems: 'center' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
                    <input
                      type="radio"
                      name="add_client_type"
                      value="private"
                      checked={addForm.client_type !== 'company'}
                      onChange={() => handleAddChange('client_type', 'private')}
                    />
                    Osoba prywatna
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
                    <input
                      type="radio"
                      name="add_client_type"
                      value="company"
                      checked={addForm.client_type === 'company'}
                      onChange={() => handleAddChange('client_type', 'company')}
                    />
                    Firma
                  </label>
                </div>
                {addForm.client_type === 'company' && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
                    <EditField>
                      <EditLabel>Nazwa firmy *</EditLabel>
                      <AddInput value={addForm.company_name} onChange={e=>handleAddChange('company_name', e.target.value)} placeholder="Firma Sp. z o.o."/>
                    </EditField>
                    <EditField>
                      <EditLabel>NIP *</EditLabel>
                      <AddInput value={addForm.company_nip} onChange={e=>handleAddChange('company_nip', e.target.value)} placeholder="1234567890" maxLength={20}/>
                    </EditField>
                    <EditField>
                      <EditLabel>REGON (opcjonalnie)</EditLabel>
                      <AddInput value={addForm.company_regon} onChange={e=>handleAddChange('company_regon', e.target.value)} placeholder="123456789" maxLength={20}/>
                    </EditField>
                  </div>
                )}
              </div>

              <EditActions>
                <SecondaryButton type="button" onClick={() => setShowAddForm(false)} disabled={addLoading}>Anuluj</SecondaryButton>
                <EditButton type="submit" disabled={addLoading} data-cy="clients-add-submit">
                  {addLoading ? 'Dodawanie...' : 'Dodaj klienta'}
                </EditButton>
              </EditActions>
            </EditForm>
          </EditBox>
        </EditOverlay>
      )}

      {/* PRZENIESIONE: Overlay z potwierdzeniem usunięcia - POZA modalem */}
      {showDeleteConfirmation && selectedClient && (
        <ConfirmationOverlay onClick={handleCancelDelete}>
          <ConfirmationBox onClick={e => e.stopPropagation()}>
            <ConfirmationTitle>
              <AlertTriangleIcon />
              {t('clients.deleteConfirmTitle')}
            </ConfirmationTitle>

            <ConfirmationText>
              {t('clients.deleteConfirmIntro')}{' '}
              <strong>{selectedClient.firstname} {selectedClient.lastname}</strong>?
              <br /><br />
              <span style={{ color: 'var(--danger)', fontWeight: '600' }}>
                <AlertTriangleIcon /> {t('common.irreversible')}
              </span>
              <br />
              {t('clients.deleteDataLoss')}
            </ConfirmationText>

            {error && (
              <div style={{
                color: 'var(--danger)',
                fontSize: '0.9rem',
                marginBottom: '20px',
                padding: '12px 16px',
                background: 'var(--danger-bg)',
                borderRadius: '12px',
                border: '1px solid var(--danger-border)',
                textAlign: 'left'
              }}>
                <strong>{t('common.error')}:</strong> {error}
              </div>
            )}

            <ConfirmationActions>
              <SecondaryButton 
                onClick={handleCancelDelete}
                disabled={deleteLoading}
                style={{ minWidth: '120px' }}
              >
                <XIcon /> Anuluj
              </SecondaryButton>
              
              <DangerButton 
                onClick={handleDeleteClient}
                disabled={deleteLoading}
                style={{ minWidth: '120px' }}
              >
                {deleteLoading ? (
                  <>
                    <div style={{ 
                      width: '16px', 
                      height: '16px', 
                      border: '2px solid transparent',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }} />
                    Usuwanie...
                  </>
                ) : (
                  <>
                    <TrashIcon />
                    Tak, usuń
                  </>
                )}
              </DangerButton>
            </ConfirmationActions>
          </ConfirmationBox>
        </ConfirmationOverlay>
      )}

      {isAdminUser && (
        <ClientExportModal
          open={showListExport}
          onClose={() => setShowListExport(false)}
          listClients={filtered}
          allClients={allClientsByName}
          listActive={Boolean(q.trim()) || filterBy !== 'all'}
          listParams={{ q, filter: filterBy, sort: sortBy }}
          allCountCapped={clients.length >= CLIENTS_LIST_LIMIT}
        />
      )}

      {/* Animacja spinner */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </LocalContainer>
  );
}